export const CUT_REGISTRATION_SAVE_REQ = 'CUT_REGISTRATION_SAVE_REQ'
export const CUT_REGISTRATION_SAVE_REQ_SUCCESS = 'CUT_REGISTRATION_SAVE_REQ_SUCCESS'
export const CUT_REGISTRATION_SAVE_REQ_FAIL = 'CUT_REGISTRATION_SAVE_REQ_FAIL'
